export function urlWithParams(nurl: string, params: Record<string, string | number>) {
  const url = new URL(nurl);
  Object.keys(params).forEach((key) => url.searchParams.append(key, params[key].toString()));
  return url.toString();
}
